// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCCOq_Wkd4Luo2R0h_7zxh3LtVYEiaIpHA",
  authDomain: "powerblocks-77c00.firebaseapp.com",
  projectId: "powerblocks-77c00",
  storageBucket: "powerblocks-77c00.appspot.com", // Corrected storageBucket
  messagingSenderId: "406963744715",
  appId: "1:406963744715:web:fe3612a428c7e9819d104e",
  measurementId: "G-N4C0V78KXT" // Optional, can be removed if not using Analytics
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore instance
const db = getFirestore(app);

export { db };